'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetState = undefined;

var _reselect = require('reselect');

var _widgetIsInAwayMode = require('../../availability/selectors/widgetIsInAwayMode');

var _widgetState = require('../constants/widgetState');

var widgetState = exports.widgetState = (0, _reselect.createSelector)(_widgetIsInAwayMode.widgetIsInAwayMode, function (widgetIsInAwayMode) {
  return widgetIsInAwayMode ? _widgetState.OFFLINE : _widgetState.ONLINE;
});


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/selectors/widgetState.js
// module id = 763
// module chunks = 2 3